import { render, staticRenderFns } from "./SalaryLogTab.vue?vue&type=template&id=7b52688d&scoped=true"
import script from "./SalaryLogTab.vue?vue&type=script&lang=js"
export * from "./SalaryLogTab.vue?vue&type=script&lang=js"
import style0 from "./SalaryLogTab.vue?vue&type=style&index=0&id=7b52688d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52688d",
  null
  
)

export default component.exports